<script>
import { mapActions } from "vuex";
import Card from "./Card";
import PreloaderTable from "@/components/_Shared/PreloaderTable";
import professionalRegisterFlowMixin from "@/mixins/professionalRegisterFlowMixin";
import Notification from "./Notification";

export default {
  mixins: [professionalRegisterFlowMixin],

  components: {
    PreloaderTable,
    Card,
    Notification
  },

  data() {
    return {
      notificationModal: false,
      bodyHeight: null
    };
  },

  props: {
    type: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },

  methods: {
    ...mapActions("professionalRegisterFlow", ["setCurrentPage", "listAll"]),

    setPage(page) {
      this.setCurrentPage(this.type, page);
    },

    onResize() {
      if (!this.$refs.list || !this.$refs.header || !this.$refs.footer) {
        return;
      }

      this.bodyHeight =
        this.$refs.list.clientHeight -
        (this.$refs.header.clientHeight + this.$refs.footer.clientHeight);
    }
  },

  computed: {
    name() {
      return this.getStatus(this.type).name;
    }
  },

  async mounted() {
    if (!this.data.list || !this.data.list.length) {
      await this.listAll(this.type);
    }

    this.onResize();
  }
};
</script>

<template>
  <div class="list" :class="{ empty_list: !data.list.length }" ref="list">
    <div class="header" ref="header">
      <span>{{ name }}</span>

      <img
        @click="notificationModal = true"
        src="/static/menu-notifications.svg"
      />
    </div>

    <div
      ref="body"
      class="body"
      :style="{
        maxHeight: bodyHeight ? bodyHeight + 'px' : 'calc(100% - 85px)'
      }"
      :class="{ empty_body: !data.list.length }"
      v-resize="onResize"
    >
      <PreloaderTable v-if="data.preloader" />

      <div v-else-if="!data.preloader && data.list.length">
        <div class="text-xs-center">
          <template v-for="professional in data.list">
            <Card :key="professional.id" :professional="professional" />
          </template>
        </div>
      </div>

      <div class="empty" v-else>
        Lista vazia.
      </div>
    </div>

    <div v-if="!data.preloader && data.list.length" ref="footer">
      <v-pagination
        v-model="data.pagination.current"
        :total-visible="5"
        :length="data.pagination.totalPages"
        @input="setPage"
      />
    </div>

    <Notification
      :opened="notificationModal"
      @close="notificationModal = false"
      :name="name"
      :status="this.type"
    />
  </div>
</template>

<style scoped>
.list {
  min-width: 275px;
  height: calc(100% - 20px);
  justify-content: space-between;
  background: #ebecf0;
  border-radius: 4px;
}

.list:not(:last-child) {
  margin-right: 16px;
}

.empty_list {
  height: fit-content;
}

.header {
  width: 100%;
  height: fit-content;
  padding: 8px;
  position: relative;
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 400;
}

span {
  max-width: 90%;
  white-space: normal;
}

img {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  position: absolute;
  right: 0;
  opacity: 0.5;
}

img:hover {
  cursor: pointer;
  opacity: 1;
}

.body {
  overflow: hidden;
  overflow-y: auto;
  padding: 8px;
}

.empty_body {
  overflow: auto;
}

.empty {
  height: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  font-weight: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/ProfessionalRegisterFlow/components/List.vue